import axios from "axios";

const getBaseURL = () => {
  if (typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")) {
    return process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.includes("localhost")
      ? process.env.REACT_APP_API_URL
      : "http://localhost:5010";
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "http://localhost:5010";
};

const API = axios.create({
  baseURL: getBaseURL(),
});

// Request interceptor to automatically add JWT Bearer token
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const fixImageUrls = (data) => {
  if (typeof data === 'string' && (data.startsWith('/uploads/') || data.startsWith('/images/'))) {
    return API.defaults.baseURL + data;
  }
  if (!data || typeof data !== 'object') return data;
  if (Array.isArray(data)) {
    return data.map(item => fixImageUrls(item));
  }
  
  const newData = { ...data };
  for (const key in newData) {
    newData[key] = fixImageUrls(newData[key]);
  }
  return newData;
};

API.interceptors.response.use((response) => {
  if (response.data) {
    response.data = fixImageUrls(response.data);
  }
  return response;
}, (error) => {
  if (error.response && error.response.status === 401) {
    if (!window.location.pathname.includes("/login")) {
      console.warn("⚠️ 401 Unauthorized — Token expired or invalid. Redirecting to login...");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userName");
      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
});

export default API;